import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule} from '@angular/common/http';

import { VendorModule } from '../core/vendor.module';
import { NgxMaskModule } from 'ngx-mask';

import { CoreModule } from '../core/core.module';
import { SecurityService } from '../security/security.service';
import { LoguedGuardService } from '../security/logued-guard.service';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SecurityModule } from '../security/security.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { PedidoComponent } from './pedido.component';
import { PedidoListComponent } from './pedido-list/pedido-list.component';
import { PedidoDetailsComponent } from './pedido-details/pedido-details.component';
import { PedidoResolver } from './pedido.resolver';
import { PedidoFilterComponent } from './pedido-filter.component';
import { PedidoTableComponent } from './pedido-table.component';
import { ArchivoService } from '../core/archivo.service';
import { CodigosPromocionComponent } from './codigos-promocion/codigos-promocion.component';
import { CodigosPromocionListComponent } from './codigos-promocion/codigos-promocion-list/codigos-promocion-list.component';
import { CodigosPromocionAddComponent } from './codigos-promocion/codigos-promocion-add/codigos-promocion-add.component';
import { PedidoProveedorListComponent } from './pedido-proveedor-list/pedido-proveedor-list.component';
import { CostoEnvioComponent } from './costo-envio/costo-envio/costo-envio.component';
import { CostoEnvioAddComponent } from './costo-envio/costo-envio-add/costo-envio-add.component';
import { CostoEnvioListComponent } from './costo-envio/costo-envio-list/costo-envio-list.component';
import { CostoEnvioMassiveComponent } from './costo-envio/costo-envio-massive/costo-envio-massive.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    NgxMaskModule,
  ],
  declarations: [
    PedidoComponent,
    PedidoListComponent,
    PedidoProveedorListComponent,
    PedidoDetailsComponent,
    PedidoFilterComponent,
    PedidoTableComponent,
    CodigosPromocionComponent,
    CodigosPromocionListComponent,
    CodigosPromocionAddComponent,
    CostoEnvioComponent,
    CostoEnvioAddComponent,
    CostoEnvioListComponent,
    CostoEnvioMassiveComponent
  ],
  exports: [
    PedidoComponent,
    PedidoListComponent,
    PedidoProveedorListComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    PedidoResolver,
    ArchivoService
  ]
})
export class PedidoModule { }



// WEBPACK FOOTER //
// ./src/app/pedido/pedido.module.ts